export const statusColor = (data) => {
  if (typeof data === "string") {
    switch (data.toLowerCase()) {
      case "pending":
        return "Cyan-500";
      case "approved":
        return "Green-150";
      case "rejected":
        return "Red-150";
      case "on_hold":
        return "Orange-150";
      case "deleted":
        return "Red-150";
      default:
        return "Gray-100";
    }
  }
  return "Gray-100";
};
